import "core-js/modules/es.array.concat.js";
import moment from "moment";
Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};
/* To be tested
Date.prototype.addHours = function (hours) {
  let date = new Date(this.valueOf())
  date.setHours(date.getHours() + hours)
  return date
}
*/
Date.addHours = function (date, hours) {
  var newDate = new Date(date);
  newDate.setHours(newDate.getHours() + hours);
  return newDate;
};
Date.diffDays = function (dateToCompare, dateReference) {
  var diffTime = dateReference.getTime() - dateToCompare.getTime();
  return Math.floor(diffTime / (1000 * 3600 * 24));
};
Date.prototype.formatForDatePickerDays = function () {
  return moment(this).format("YYYY-MM-DD");
};
moment.fn.formatForDatePickerDays = function () {
  return this.format("YYYY-MM-DD");
};
Date.prototype.formatForDatePickerMonths = function () {
  return moment(this).format("YYYY-MM");
};
moment.fn.formatForDatePickerMonths = function () {
  return this.format("YYYY-MM");
};
Date.prototype.formatStringMonth = function () {
  return moment(this).format("MMMM YYYY");
};
moment.fn.formatStringMonth = function () {
  return this.format("MMMM YYYY");
};
Date.prototype.formatDate = function () {
  return moment(this).format("MM/DD/YYYY");
};
moment.fn.formatDate = function () {
  return this.format("MM/DD/YYYY");
};
Date.prototype.formatDateTime = function () {
  return moment(this).format("MM/DD/YYYY HH:mm");
};
moment.fn.formatDate = function () {
  return this.format("MM/DD/YYYY HH:mm");
};
Date.prototype.formatDateFullText = function () {
  return moment(this).format("MMMM D, YYYY");
};
Date.prototype.formatMinutesToDaysHoursMinutes = function (minutes) {
  var forcedLastUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var momentDuration = moment.duration(minutes, "minutes");
  var days = Math.floor(momentDuration.asDays());
  var hours = momentDuration.hours();
  var mins = momentDuration.minutes();
  if (days > 0) {
    if (hours > 0 || forcedLastUnit) {
      return "".concat(days, " day").concat(days > 1 ? "s" : "", ", ").concat(hours, " hour").concat(hours > 1 ? "s" : "");
    } else {
      return "".concat(days, " day").concat(days > 1 ? "s" : "");
    }
  } else if (hours > 0) {
    if (mins > 0 || forcedLastUnit) {
      return "".concat(hours, " hour").concat(hours !== 1 ? "s" : "", ", ").concat(mins > 10 ? mins : "0" + mins, " minute").concat(mins > 1 ? "s" : "");
    } else {
      return "".concat(hours, " hour").concat(hours !== 1 ? "s" : "");
    }
  } else {
    return "".concat(mins, " minute").concat(mins !== 1 ? "s" : "");
  }
};